import { Scrollbars } from "react-custom-scrollbars";
import styled from "styled-components";

export const Wrapper = styled(Scrollbars)`
	width: 100%;
	height: 100%;
	padding: 0 10px 0 0;
`;
